export var CardsEnum;
(function (CardsEnum) {
    CardsEnum["visa"] = "visa";
    CardsEnum["mastercard"] = "mastercard";
    CardsEnum["master_card"] = "master card";
    CardsEnum["diners"] = "diners";
    CardsEnum["discover"] = "discover";
    CardsEnum["amex"] = "amex";
    CardsEnum["american_express"] = "american express";
    CardsEnum["alia"] = "alia";
    CardsEnum["transfer"] = "transfer";
    CardsEnum["cash"] = "cash";
    CardsEnum["jcb"] = "jcb";
    CardsEnum["carnet"] = "carnet";
})(CardsEnum || (CardsEnum = {}));
export var CardTypeEnum;
(function (CardTypeEnum) {
    CardTypeEnum["DEBIT"] = "debit";
    CardTypeEnum["CREDIT"] = "credit";
})(CardTypeEnum || (CardTypeEnum = {}));
